<template>
    <v-card width="inherit" style="height:100%" class="dataTableCard">
        <v-card-title class="title" v-if="showQuestionNumber">
            {{currentQuestion}}
        </v-card-title>
        <v-card-text>
            <v-data-table :headers="headerData"
                          :items="tableData"
                          class="elevation-1"
                          header-props.sort-icon
                          hide-default-footer
                          calculate-widths
                          disable-sort
                          dense>
                <template v-for="(header,index) in headerData" v-slot:[`item.${header.value}`]="{ item }">
                    <!--<span v-html="item.displayName"></span>-->
                    <span v-html="item[header.value]" :key="index"></span>
                </template>
          </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        data() {
            return {
                //search: "",
            };
        },
        computed: {
            ...mapState({
                currentQuestion: state => state.SegmentMeasureStore.currentQuestion,
            }),
        },
        props: ['headerData', 'tableData', 'showQuestionNumber'],
        created() {
        }
    };
</script>
<style scoped>
    table thead th.word-wrap {
        word-wrap: break-word;
        text-align: left;
        white-space: normal;
        color: #005582;
        font-weight: bold;
        /*font-size: 1.6vh;*/
    }

    @media (max-height: 824px) {
        /*Header row styles*/
        table thead th.word-wrap {
            font-size: 11px;
            padding: 0px 21px 0px 21px;
        }

        table .v-table thead tr {
            height: 4.8vh !important;
        }

        table.v-table tbody td {
            font-size: 11px;
            height: 4.2vh;
        }

        .dataTableCard .v-card__text {
            padding-top: 1vh;
            padding-bottom: 1vh;
        }

        .dataTableCard .material-icons {
            font-size: 1.6vh !important;
        }

        .dataTableHeaderRow {
            height: 4.8vh !important;
        }
    }

    @media (min-height: 825px) and (max-height:1024px) {
        /*Header row styles*/
        table thead th.word-wrap {
            font-size: 12px;
        }

        /*table .v-table thead tr {*/
        .dataTableHeaderRow {
            height: 48px !important;
        }

        table.v-table tbody td {
            font-size: 12px;
            height: 42.7px;
        }

        .dataTableCard .v-card__text {
            padding-top: 10px;
            padding-bottom: 10px;
        }

        .dataTableCard .material-icons {
            font-size: 16px !important;
        }
    }

    @media (min-height: 1025px) {
        /*Header row styles*/
        table thead th.word-wrap {
            font-size: 14px;
        }

        .dataTableHeaderRow {
            height: 48px !important;
        }

        table.v-table tbody td {
            font-size: 14px;
            height: 4.8vh
        }

        .dataTableCard .v-card__text {
            padding-top: 8vh;
            padding-bottom: 8vh;
        }
    }

    @media (max-height: 650px) {
        /*Header row styles*/
        table thead th.word-wrap {
            font-size: 11px;
            padding: 0px 12px 0px 12px;
        }
    }
</style>
